export const resolveSessionTopMargin = ({
    topMargin,
    isEventIndependent,
    isVirtualVenueEnabled,
    hasSessionBanner,
}) =>
    topMargin
    || (isEventIndependent && 'single')
    || (isVirtualVenueEnabled || hasSessionBanner ? 'double' : 'single');
